import React, { useState, useContext, useEffect } from 'react'

import { GlobalStateContext, GlobalDispatchContext } from '../context/appContext'
import { getPageTypeFromPathname } from '../lib/helpers'

import InnerExpansionPanel from '../mui-components/ExpansionPanel/ExpansionPanel'

function ExpansionPanel(props) {
  const dispatch = useContext(GlobalDispatchContext)
  const id = props.id !== undefined ? props.id : null
  const state = useContext(GlobalStateContext)

  // Check if we should save expanded state to the context
  const rememberExpanded = props.rememberExpanded

  // Note: If props.location is not passed, pageType will return null
  const pageType = getPageTypeFromPathname(props)

  const [expanded, setExpanded] = useState(() => {
    // Check if we have all necessary values
    if (!rememberExpanded || !id || !pageType || !state || !state.expandedPanels) {
      return false
    }

    // Also check if panel shouldn't be closed (i.e. was expanded by default and manually closed)
    if (props.isDefaultExpanded && state.expandedPanels['manually-closed'].indexOf(id) > -1) {
      return false
    }

    // Check if panel should be opened by default, this condition has to come after we check if panel is manually closed
    if (props.isDefaultExpanded) {
      return true
    }

    // Check if there is saved expanded state for this panel and set it as initial
    return state.expandedPanels[pageType].indexOf(id) > -1 || false
  })

  // Check for all panels which should be expanded by default (set via prop)
  useEffect(() => {
    if (props.isDefaultExpanded) {
      dispatch({
        handler: 'changeExpandedPanels',
        pageType: pageType,
        id: id,
        add: true
      })
    }
  }, [])

  const handleChange = () => {
    // Update global context array, so we can preserve expanded state
    if (rememberExpanded && id && pageType) {
      dispatch({
        handler: 'changeExpandedPanels',
        pageType: pageType,
        id: id,
        add: !expanded, // panel already closed and is expanding
        remove: expanded // panel already expanded and is closing
      })
    }

    // Also check if panel isn't expanded by default
    // When we are closing it, we add it to separate array so we can check for them later
    if (props.isDefaultExpanded) {
      // We need to flip add/remove logic, so we use "add" when panel is closing and "remove" when panel is expanding
      dispatch({
        handler: 'changeManuallyClosedPanels',
        pageType: pageType,
        id: id,
        add: expanded,
        remove: !expanded
      })
    }

    // Actually change expanded state
    setExpanded(!expanded)
  }

  return <InnerExpansionPanel {...props} expanded={expanded} onChange={handleChange} />
}

export default ExpansionPanel
